<template>
  <el-select class="picker" size="small" v-model="partySizeSelected" placeholder="select party #" @change="partySizeChange">
    <el-option
      v-for="ps in partySizes"
      :key="ps.value"
      :label="ps.label"
      :value="ps.value">
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: "partySizePicker",
  props: [ 'partySize' ],
  data() {
    return {
      // partySizeSelected: null
    }
  },
  watch: {
    location( loc ) {
      if ( this.partySizeSelected > this.maxPartySize ) {
        this.partySizeSelected = this.maxPartySize
      }
    }
  },
  computed: {
    partySizeSelected: {
      get() {
        return this.partySize
      },
      set( val ) {
        this.$emit( 'partySizeChange' , val )
      }
    },
    location() {
      return this.$store.state.availability.location
    },
    maxPartySize() {
      if ( this.location == "greensboro" ) {
        return 8
      } else if ( this.location == "winston" ) {
        return 8
      }

      return 8
    },
    partySizes() {
      let ps = []

      for ( let i = this.maxPartySize ; i > 0 ; i-- ) { //changed from i = 10 to i = 8 due to covid
        let l = ( i == 1 ) ? "1 person" : i + " people"
        let p = {
          value: i,
          label: l
        }
        ps.push( p )
      }

      return ps
    },
  },
  methods: {
    partySizeChange( ps ) {
      // this.$emit( 'partySizeChange' , ps )
    }
  },
  mounted() {
  }
}

</script>

<style lang="scss" scoped>

.picker {
  float: left;
  clear: left;
  width: 150px !important;
  @media screen and (max-width: 768px) {
    width: 100%;
    width: 95% !important;
  }
  @media screen and (max-width: 425px) {
    width: 100% !important;
  }
}
</style>